import {Component, EventEmitter, Input, Output} from '@angular/core';
import {PrimaryButtonComponent} from "../../primary-button/primary-button.component";
import {NgIf} from "@angular/common";
import {TranslateModule} from "@ngx-translate/core";

@Component({
  selector: 'app-single-step',
  templateUrl: './single-step.component.html',
  standalone: true,
  imports: [
    PrimaryButtonComponent,
    NgIf,
    TranslateModule
  ],
  styleUrls: ['./single-step.component.scss']
})
export class SingleStepComponent {
  @Input() title: any;
  @Input() icon: any;
  @Input() percentOfOneSection = 100;
  @Input() showNextPrevButtons = false;
  @Output() onUpdate: EventEmitter<any>;

  constructor() {
    this.onUpdate = new EventEmitter<any>();
  }

  onNextClick(){
    this.onUpdate.emit();
  }
}
